import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import polygon from 'assets/svg/shadowPolygon.svg';
import { Opacity } from '@mui/icons-material';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      color: theme.palette.common.white
    },
    tabs: {
      display: 'flex',
      alignItems: 'center',
      background: '#CBC1FF85',
      borderRadius: 50,
      padding: 10,
      gap: 20
    },
    tab: {
      flex: '1 0 30%',
      height: 94,
      borderRadius: 50,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px 20px',
      '& svg': {
        width: '100%',
        height: 'auto',
        maxHeight: '100%',
        maxWidth: 320
      },
      '&:not(:last-child)::after': {
        position: 'absolute',
        content: '""',
        top: 30,
        bottom: 30,
        right: -10,
        width: 2,
        background: theme.palette.common.white,
        opacity: 0.2
      },
      '&.active': {
        background: theme.palette.common.white,
        '&::before': {
          position: 'absolute',
          content: '""',
          width: 55,
          height: 48,
          bottom: -39,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundImage: `url(${polygon})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center top',
          backgroundSize: '55px auto'
        }
      }
    },
    slideContent: {
      position: 'relative',
      boxSizing: 'border-box',
      background: theme.palette.common.white,
      height: 64,
      borderRadius: 50,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px 20px',
      marginTop: 15,
      marginBottom: 25,
      '& svg': {
        width: '100%',
        height: 'auto',
        maxHeight: '100%'
      },
      '&::before': {
        position: 'absolute',
        content: '""',
        width: 25,
        height: 22,
        bottom: -20,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundImage: `url(${polygon})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: '25px auto'
      }
    }
  }), { name: 'OperatorTabPanel' }
);
